import React from "react";
import { withRouter } from "react-router-dom";
import Header from "./header";
import {
  useSmarkState,
  useSmarkDispatch,
} from "../../Context/KeycloakContext";

function HeaderContainer(props) {
  const { isAdminUI, userId,projectPermissions, } = useSmarkState();
  const dispatch = useSmarkDispatch();

  

  return (
    <Header
      {...props}
      isAdmin={isAdminUI}
      userId={userId}
      projectPermissions={projectPermissions}
      dispatch={dispatch}   
    />
  );
}

export default withRouter(HeaderContainer);
